import { IGetTopBetsByAnnouncementRequest } from '../../../../../repositories/auction/v2/get-top-bets-by-announcement';
import { ETopBetsErrorCode } from '../../../../reducers';

export function validateTopBetsRequestParams(request: IGetTopBetsByAnnouncementRequest): ETopBetsErrorCode | null {
  const { price, geoType, geoId, service } = request;

  const isPriceEmpty = !price;
  const isGeoEmpty = !geoId || !geoType;

  if (isPriceEmpty && isGeoEmpty) {
    return ETopBetsErrorCode.priceAndGeoEmpty;
  }

  if (isGeoEmpty) {
    return ETopBetsErrorCode.geoEmpty;
  }

  if (isPriceEmpty) {
    return ETopBetsErrorCode.priceEmpty;
  }

  if (!service) {
    return ETopBetsErrorCode.serviceNotSupported;
  }

  return null;
}
